<article id="{{slug}}HomeSection"
         class="w-full flex justify-content-center align-items-center bg-black-alpha-10 overflow-hidden relative"
         [ngClass]="{'flex-row-reverse': invert}"
         style="height: 100dvh;">
  <section *ngIf="data?.name"
           class="ci-information-preview w-full lg:w-6 h-full ci-main-padding flex flex-column gap-3 bg-cover justify-content-center shadow-3 lg:shadow-none relative"
           [ngClass]="{'align-items-end': invert}">
    <section *ngIf="data?.features?.length > 0"
             class="flex align-items-center gap-3 lg:gap-5 z-3">
      <i *ngFor="let item of data.features"
         class="bi {{item.icon}} text-6xl ci-txt--{{data.color}}"></i>
    </section>
    
    <h4 class="text-3xl sm:text-4xl lg:text-5xl z-3"
        [ngClass]="{'text-right': invert}">
      {{data.name}}
    </h4>

    <p class="text-xl sm:text-2xl lg:text-3xl z-3"
       [ngClass]="{'text-right': invert}">
      {{data.description}}
    </p>

    <button *ngIf="!data.redirect"
            class="mt-3 z-3 w-fit ci-btn ci-bg--{{data.color}}"
            (click)="scrollToTop()"
            [routerLink]="['/project/' + this.data.slug]">
      Ver más
    </button>

    <section class="lg:hidden w-full h-full z-2 absolute top-0 right-0 left-0 bottom-0 bg-cover bg-center"
             style="background: url({{data.assets.previewBgUrl}});">
      <section class="w-full h-full bg-black-alpha-60">
      </section>
    </section>
  </section>

  <section *ngIf="data?.assets?.previewBgUrl"
           class="hidden lg:block w-full h-full lg:w-6 bg-cover shadow-3 overflow-hidden">
    <section class="w-full h-full bg-cover bg-no-repeat bg-center"
             style="background: url({{data.assets.previewBgUrl}});"></section>
  </section>

  <section *ngIf="scrollSectionId" (click)="scrollToFeatureSection()" 
           class="flex justify-content-center mt-3 fadeindown animation-duration-500 z-3 absolute bottom-0 right-0 left-0 mb-5">
    <section class="p-2 bg-black-alpha-30 ci-project-banner__arrow-down border-round-3xl">
      <i class="bi bi-chevron-double-down ci-txt--white text-3xl md:text-4xl cursor-pointer">
    </i>
    </section>
  </section>
</article>